import React from 'react';

const TimelineMerchantDeny = ({ fill }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 13 17.3"
      xmlSpace="preserve"
      fill={fill}
      className="card-icon"
    >
      <title>Merchant Deny</title>
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-577.000000, -1695.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Merchant-Deny" transform="translate(0.000000, 792.000000)">
                <g id="Icon" transform="translate(31.000000, 0.000000)">
                  <g id="Avatar">
                    <g id="file-alt-light" transform="translate(14.000000, 19.000000)">
                      <path
                        id="Shape"
                        fill={fill}
                        d="M11.6357143,5.77857143 L9.41428571,8 L11.6357143,10.2214286 C11.8035714,10.3892857 11.8035714,10.6607143 11.6357143,10.8285714 L10.8285714,11.6357143 C10.6607143,11.8035714 10.3892857,11.8035714 10.2214286,11.6357143 L8,9.41428571 L5.77857143,11.6357143 C5.61071429,11.8035714 5.33928571,11.8035714 5.17142857,11.6357143 L4.36428571,10.8285714 C4.19642857,10.6607143 4.19642857,10.3892857 4.36428571,10.2214286 L6.58571429,8 L4.36428571,5.77857143 C4.19642857,5.61071429 4.19642857,5.33928571 4.36428571,5.17142857 L5.17142857,4.36428571 C5.33928571,4.19642857 5.61071429,4.19642857 5.77857143,4.36428571 L8,6.58571429 L10.2214286,4.36428571 C10.3892857,4.19642857 10.6607143,4.19642857 10.8285714,4.36428571 L11.6357143,5.17142857 C11.8035714,5.33928571 11.8035714,5.61071429 11.6357143,5.77857143 L11.6357143,5.77857143 Z M16,1.71428571 L16,14.2857143 C16,15.2321429 15.2321429,16 14.2857143,16 L1.71428571,16 C0.767857143,16 0,15.2321429 0,14.2857143 L0,1.71428571 C0,0.767857143 0.767857143,0 1.71428571,0 L14.2857143,0 C15.2321429,0 16,0.767857143 16,1.71428571 Z M14.2857143,14.0714286 L14.2857143,1.92857143 C14.2857143,1.81071429 14.1892857,1.71428571 14.0714286,1.71428571 L1.92857143,1.71428571 C1.81071429,1.71428571 1.71428571,1.81071429 1.71428571,1.92857143 L1.71428571,14.0714286 C1.71428571,14.1892857 1.81071429,14.2857143 1.92857143,14.2857143 L14.0714286,14.2857143 C14.1892857,14.2857143 14.2857143,14.1892857 14.2857143,14.0714286 Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelineMerchantDeny;

